module.exports = __webpack_public_path__ + "static/img/99-1.a52644b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/99-1.jpg
// module id = aLeq
// module chunks = 0